import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeaturedCategories() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            五大核心内容板块，全方位覆盖初音岛系列的所有精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat, index) => {
            const bgClass = index === 0 ? 'bg-primary-50 border-primary-200 hover:border-primary-300' :
                           index === 1 ? 'bg-accent-50 border-accent-200 hover:border-accent-300' :
                           index === 2 ? 'bg-secondary-50 border-secondary-200 hover:border-secondary-300' :
                           index === 3 ? 'bg-accent-50 border-accent-200 hover:border-accent-300' :
                           'bg-primary-50 border-primary-200 hover:border-primary-300';
            const iconClass = index === 0 ? 'text-primary-500' :
                             index === 1 ? 'text-accent-500' :
                             index === 2 ? 'text-secondary-500' :
                             index === 3 ? 'text-accent-500' :
                             'text-primary-500';

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center text-center p-6 rounded-lg border transition-all duration-300 cursor-pointer ${bgClass}`}
              >
                <span className={`w-12 h-12 flex items-center justify-center mb-3 ${iconClass}`}>
                  <i className={`${cat.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}